import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import PageCard from './PageCard'

const styles = (theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    minHeight: 96,
    height: '100%',
  },
  iconWrap: {
    width: 48,
    height: 48,
    borderRadius: 14,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  content: {
    minWidth: 0,
  },
  value: {
    fontSize: '1.5rem',
    fontWeight: 700,
    lineHeight: 1.2,
    color: theme.palette.text.primary,
  },
  label: {
    marginTop: 2,
    fontSize: '0.875rem',
    color: theme.palette.text.secondary,
  },
})

function StatCard({ classes, icon, label, value, color = '#5b6cff', bg = '#eef1ff' }) {
  return (
    <PageCard>
      <div className={classes.root}>
        <div className={classes.iconWrap} style={{ backgroundColor: bg, color }}>
          {icon}
        </div>
        <div className={classes.content}>
          <Typography className={classes.value}>{value}</Typography>
          <Typography className={classes.label}>{label}</Typography>
        </div>
      </div>
    </PageCard>
  )
}

StatCard.propTypes = {
  classes: PropTypes.object.isRequired,
  icon: PropTypes.node,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  color: PropTypes.string,
  bg: PropTypes.string,
}

export default withStyles(styles)(StatCard)
